import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { NotifyService } from 'src/app/Service/notify.service';
import { DataService } from 'src/app/Service/data.service';
import { Factura } from 'src/app/Models/factura/factura';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { DetalleFactura } from 'src/app/Models/factura/detallefactura/detalle-factura';
import { AlertComponent } from '../../objects/alert/alert/alert.component';

@Component({
  selector: 'app-search-factura',
  templateUrl: './search-factura.component.html',
  styleUrls: ['./search-factura.component.css']
})
export class SearchFacturaComponent implements OnInit {
  public isShow: boolean = false;
  public funcion: Function =  null;
  @ViewChild('btnshowFactura', null) btnshowFactura: ElementRef;
  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('artloading', null) artloading: LoadingComponent;
  @ViewChild('artinfo', null) artinfo: InfoComponent;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  public pagina: number = 0;
  public search = { top: 10, clase: 0, subclase: 0, subgrupo: 0, nombre: '', codigo: '', opcion: 'fecha', scale: 'DESC', fechaprogd: this.data.DateNowCurrent(), fechaprogh: this.data.DateNowCurrent() }
  public filtro:Filtro = new Filtro();
  public facturas:Factura[]=[];
  public factura:Factura = new Factura();
  public detallefactura:DetalleFactura = new DetalleFactura();
  public fecha:string='';
  public pagart: any;
  public detfactus:any[]=[];
  public usuario = null;
  public showdelete:boolean = false;
  public modal="modal-lg";
  constructor(private data: DataService, private notify: NotifyService) { 
    
  }

  ngOnInit() {
  }

  public show(affterfunction: Function = null) {
    this.funcion = affterfunction;
    this.isShow = true;
    this.showTab(1);
    this.showdelete=false;
    setTimeout(() => {
        this.btnshowFactura.nativeElement.click();
        this.GetData();
        this.info.hide();
        this.usuario = this.data.getCurrentUser();
        this.filtro.idsucursal = this.data.getSucursalId()
  
    }, 10);
}

  GetData(){
    if (!this.filtro) {
      this.data.GetFromValue(this.data.api.factura,'documen','FAC').subscribe(r=>{
        r.length>0?this.facturas=r.data:this.facturas=[]
      })
    }else{
      
      this.data.Post('filtrardoc/Factura',this.filtro).subscribe(r=>{
        console.log(r)
        r.status=='success'?this.facturas=r.data:this.facturas=[]
      })
    }
  }

  showTab(i) {

    this.pagina = i;
    if(this.pagina == 1){this.modal ='modal-lg';}
    else{this.modal='';}
  }
  
  SearchData(){
    if (!this.filtro) {
      this.data.GetFromValue(this.data.api.factura,'like',this.fecha).subscribe(r=>{
        r.length>0?this.facturas=r:this.facturas=[]
        console.log(this.facturas);
      })
    }else{
      this.data.Post('filtrardoc/Factura',this.filtro).subscribe(r=>{
        console.log(r)
        r.status=='success'?this.facturas=r.data:this.facturas=[]
        console.log(this.facturas);
      })
    }
  }

  close() {
      this.btnclose.nativeElement.click();
      setTimeout(() => { this.isShow=false; }, 1000);
      setTimeout(() => {if (this.funcion != null) { this.funcion(); } }, 10);
  }

  SelectItem(i){
    try {
      this.factura = i as Factura;
      console.log(this.factura);
      this.data.GetFromValue(this.data.api.detfactura,'idfactura',this.factura.idfactura.toString()).subscribe(r=>{
        console.log(r);
        this.detfactus=r;
        this.close();
      })
    } catch (error) {
      this.notify.Notify(0,"Detalles no encontrados")
    }
    
}
}
